// @ts-ignore
import MoreInfoImg from './assets/more_info_popup.png';

// @ts-ignore
import FaqImg from './assets/faq.png';

// @ts-ignore
import FloatingVideoImg from './assets/floating_video.png';

// @ts-ignore
import NotificationImg from './assets/notification.png';

// @ts-ignore
import OverlayImg from './assets/personalized_popup.png';

// @ts-ignore
import ScrollableOverlay from './assets/scrollable_popup.png';

// @ts-ignore
import CopyCodeImg from './assets/copy_code.png';

// @ts-ignore
import CartIsReadyImg from './assets/cart_is_ready.png';

// @ts-ignore
import StickyAtcImg from './assets/sticky_atc.png';

// @ts-ignore
import TrendingCollectionsImg from './assets/trending_collections.png';

// @ts-ignore
import BuyAgainImg from './assets/buy_again.png';

export interface StarterUseCase {
  title: string;
  description?: string;
  image: string;
  prompt?: string;
  sendPrompt?: boolean;
  openImage?: boolean;
  openSketch?: boolean;
  tags: string[];
}

export const STARTER_USE_CASES: StarterUseCase[] = [
  {
    title: `Add a floating video`,
    image: FloatingVideoImg,
    tags: [`All`, `Overlays`],
    prompt: `Create a "Floating Video" that will show upon page load with the following spec:

Overlay Behavior
  - Overlay can be closed via a close button.
  - Should be draggable around the screen also in mobile.
  - Should auto play and loop the video.
  - When clicking on the video animate the expansion to full screen.

Overlay Components
  1. Floating like element with a shadow and rounded corners. inside that wrapper there should be a video player that can play mp4 videos.
  2. Overlayed play/pause button on the bottom-left corner of the video.
  3. Overlayed close button on the top-right corner of the video.

Full Screen Overlay Behavior
  - When the video is clicked it should animate to full screen.
  - In full screen mode the video should be centered horizontally and vertically on the screen.
  - In full screen mode the video should have a close button on the top-right corner to exit full screen mode.

Overlay Style
  - Use a subtle shadow to give the floating video a slight elevation effect.
  - Use rounded corners with a radius of 8px.
  - The floating video should have a play/pause button overlayed on the bottom-left corner
  - The overlay should be positioned on the bottom-right corner of the screen with a margin of 20px from the bottom and right edges.
  `,
    sendPrompt: true,
  },
  {
    title: `Add "Cart Ready" (Expandable)`,
    image: CartIsReadyImg,
    tags: [`All`, `Sale Boosters`, `Upsells`],
    prompt: `Cart Ready Section - Reusable Component Prompt

Create an expandable cart section widget with the following specifications:

Layout & Behavior:

Inline block component (not overlay/fixed positioning)
Default state: collapsed, showing only a pill-shaped toggle button with text "Your cart is ready" and dropdown arrow
Expanded state: shows full cart details including items list and checkout section
Click the pill button to toggle between collapsed/expanded states
Arrow rotates 180 degrees when expanded
Cart Items Display:
Only show the pill when cart has items; hide the entire component if cart is empty
Iterate through live cart items using window.loomi_ctx.cart
Each cart item row contains:
Product image (80px x 60px on mobile, maintain aspect ratio)
Item name
Quantity display (e.g., "Quantity: 2")
Current price
Compare at price (if available, with strikethrough styling)
Use JavaScript template for dynamic cart item rendering
Show "Your cart is empty" message when no items
Footer Section:

Total amount display with label "Total:" and formatted price
"Checkout Now" button linking to store's checkout page
Use store's checkout URL format
Styling Requirements:

Consistent white background throughout (no different background colors)
No header/title section
Primary color for pill button and checkout button: use store's primary brand color
Typography: use store's installed font family (system fonts as fallback)
Border radius: 999px for pill button, 12px for expanded section, 6-8px for images/buttons
Subtle shadows and borders for depth
Responsive design with mobile optimizations
Technical Implementation:

Listen for cart changes with targeting-changed event
Format prices using cart currency
Handle multiple image sources (item.image, item.featured_image.url, placeholder)
Include animation toggle functionality
Use semantic HTML with proper accessibility attributes
Template-based rendering for cart items with proper attributes
Responsive Behavior:

Mobile: smaller images (60px), adjusted padding, full-width layout
Desktop: larger images (80px), centered max-width container
Smooth animations for expand/collapse (can be toggled off)`,
    sendPrompt: true,
  },
  {
    title: `Add "More Info" overlay`,
    image: MoreInfoImg,
    tags: [`All`, `Overlays`],
    prompt: `Create a "More Info" button that opens a overlay with the following spec:

Trigger
  - A button styled as a link, labeled "More Info".
  - The button is placed inside a container:
  - Container spans 100% width of the parent.
  - Button is centered horizontally in the container.

Overlay Behavior
  - Clicking the button opens the overlay.
  - Overlay is centered horizontally and vertically on the screen.
  - Overlay can be closed via a close button.
  - Inner content should be scrollable.

Overlay Components
  1.  Header - Rich-text title.
  2.  Close Button - An "X" button placed at the top-right corner of the overlay.
  3.  Text Content - Rich-text paragraph.
  4.  Image - Full-width image (spans 100% of overlay's content area).

Responsive Layout
  - Mobile (viewport < desktop breakpoint): Overlay size: 90vw width × 90vh height.
  - Desktop: Overlay size: 50vw width × 50vh height.`,
    sendPrompt: true,
  },
  {
    title: `Add recommendations for trending categories`,
    image: TrendingCollectionsImg,
    tags: [`All`, `Upsells`, `Sale Boosters`],
    prompt: `# Collection Navigation Tiles Widget

Create a horizontal, scrollable collection navigation widget that displays store collections as visually appealing tiles.

## Layout & Structure

- Horizontal scrolling tiles with smooth touch/swipe support
- Card-based design with subtle borders
- Image positioned at the top:
- Collection title displayed below the image in centered text

## Visual Design

- Clean white background
- Light gray borders (\`#E0E0E0\`)
- Hover effects:
  - Tile lift animation
  - Shadow appearance
  - Border color change
- Product images:
  - \`cover\` fit
  - Center positioning
- Gradient masks on left/right edges for smooth scroll indication
- Loading state with animated placeholder tiles

## Functionality

- Fetch collections dynamically from the **Collections API**
- Smart image mapping based on collection handles or keywords
- Configurable maximum number of collections to display
- Center alignment when tiles do not fill the container width
- Smooth scrolling behavior with full touch support

## Technical Requirements
- Template-based dynamic rendering
- Error handling for failed image loads
- Accessibility support:
  - ARIA labels
  - Focus states
- Animation system with enable/disable toggle
- \`10px\` top and bottom padding for proper spacing

## Customization Options

- Maximum collections count
- Gradient mask enable/disable
- Gradient mask background color
- Animation enable/disable toggle`,
    sendPrompt: true,
  },
  {
    title: `Add in-app notification popup`,
    image: NotificationImg,
    tags: [`All`, `Notifications`],
    prompt: `Create an "In-App Notification Popup" that appears at the top-right corner of the screen with the following spec:
     The notification should be fixed to the top-right corner of the viewport, with a margin of 20px from the top and right edges.
     Animate the notification to slide in from the right when it appears and slide out to the right when it disappears.

Overlay Components
  1.  Icon - A emoji icon on the left side of the notification.
  2.  Text Content - Rich-text paragraph next to the icon.
  3.  Close Button - An "X" button on the far right side of the notification.

Overlay Behavior
  - The notification should automatically disappear after 5 seconds.
  - The notification can be closed immediately by clicking the close button.
  - Expose a variable that will disable the auto hide

Overlay Style
  - Use a subtle shadow to give the notification a slight elevation effect.
  - Use rounded corners with a radius of 8px.
  - Ensure the notification is responsive and looks good on both mobile and desktop devices.
  - Use a light green background color for the notification to indicate success
  - Use white color for the text and icon
  - The layout should be a horizontal flexbox with the icon, text content, aligned center vertically and spaced evenly horizontally
  - The close button should be on the far top-right side of the notification

Responsive Layout
  - Mobile (viewport < desktop breakpoint): Notification size: 90vw width × auto height.
  - Desktop: Notification size: 300px width × auto height.
  - On mobile the fixed wrapper should behave like this:
    position: fixed; top: 20px; left: 0; width: 100%; right: 0; display: flex; justify-content: center; align-items: center;
  - On desktop the fixed wrapper should behave like this:
    position: fixed; top: 20px; right: 20px, left: unset; transform: none width: auto;
`,
    sendPrompt: true,
  },
  {
    title: `Add Promotion popup`,
    image: OverlayImg,
    tags: [`All`, `Overlays`, `Notifications`],
    prompt: `Create a "Promotion Popup" that will show upon page load with the following spec:

Overlay Behavior
  - Overlay is centered horizontally and vertically on the screen.
  - Overlay can be closed via a close button.
  - Inner content should be scrollable.

Overlay Components
  1.  Header - Rich-text title. don't use grid to layout the header just use flexbox that spans the full width of the overlay.
  2.  Text Content - Rich-text paragraph.
  3.  CTA - A button styled as a primary button.
  4.  Background Image - Full-width image (spans 100% of overlay's content area).

Responsive Layout
  - Mobile (viewport < desktop breakpoint): Overlay size: 90vw width × 90vh height.
  - Desktop: Overlay size: 50vw width × 50vh height.
  - On Desktop display the image on the right half of the overlay and the text content and cta on the left half of the overlay.
  `,
    sendPrompt: true,
  },
  {
    title: `Add promo code with copy button`,
    image: CopyCodeImg,
    tags: [`All`, `Sale Boosters`],
    prompt: `Create a single-line copy code banner widget with the following specifications:

Layout & Structure:
One horizontal line with two elements side by side
Left: Rich text message (editable) saying "Get 20% off your first order -"
Right: "Copy Code" button with underline styling
All content centered horizontally and vertically
10px top and bottom padding

Styling Requirements:
Use store's primary CTA color for the copy button text
Copy button should have underline text decoration and hover effects
Clean, minimal design matching the store's aesthetic
Responsive design that works on mobile and desktop
Fade-in animation on load (with toggle option)

Functionality:
Copy button copies a configurable discount code to clipboard
Show popup feedback displaying the actual code that was copied (format: "WELCOME20 Copied!")
Popup appears above the button for 2 seconds
Include fallback clipboard functionality for older browsers
Make the discount code easily configurable via JavaScript variable

Technical Requirements:
Rich text editing capability for the main message
Plain text editing for the button text
Exposed JavaScript variable for the discount code
Click tracking integration
Animation toggle functionality
Mobile-responsive with appropriate font size adjustments
Default Values:

Message: Generate creative message in the main language of the store
Button text: Something similar to "Copy Code" in the store's main language
Discount code: "WELCOME20" or something similar in capital english letters
Feedback message: Something similar to "[CODE] Copied!" in the store's main language`,
    sendPrompt: true,
  },
  {
    title: `Add sticky add to cart button`,
    image: StickyAtcImg,
    tags: [`All`, `Sale Boosters`],
    prompt: `Create a sticky add to cart overlay that appears at the bottom of the page when viewing a product. The overlay should:

Layout Requirements:

Show only after user scrolls down 300px from top (make this configurable)
Stick to bottom of screen with fixed positioning
Use three-column layout: product image | content section | add to cart button
On mobile: take full width of device
On desktop: center the content with max width container
Content Section (middle column):

Product title (handle long titles gracefully without breaking layout)
Product reviews score & star rating display
Product price & compare at price (if available)
Functionality:

Product image should maintain original aspect ratio
Fetch current product data dynamically (don't hardcode)
Add to cart button should handle both single and multiple variant products appropriately
When add to cart is clicked, scroll to top of page (make scroll target configurable via selector)
Show/hide overlay smoothly based on scroll position
Include proper tracking for add to cart events
Technical Requirements:

Make scroll threshold configurable (default 300px)
Make scroll target selector configurable (default 'body')
Include animation toggle option
Use responsive design with mobile-first approach
Fetch product data using available APIs rather than hardcoding
Handle products with and without compare at pricing
Handle products with and without reviews
Include proper error handling for missing product data
Visual Style:

Match the store's existing design system and color scheme
Use clean, minimal design with subtle shadow/border
Ensure good contrast and accessibility
Include smooth fade in/out animations (toggleable)`,
    sendPrompt: true,
  },
  {
    title: `Add a “Buy Again” block with recently purchased products`,
    image: BuyAgainImg,
    tags: [`All`, `Upsells`, `Sale Boosters`],
    prompt: `Create a "Last Item Purchased" widget that displays the most recently purchased product for returning customers. The widget should completely hide if no purchase history is found, making it perfect for personalized experiences.

Key Requirements
Functionality
Use the PAST_PURCHASES recommendation strategy to fetch the customer's most recent purchase
Display only 1 product (the last purchased item)
Completely hide the entire widget if no purchase history is found (no fallback message)
Include add to cart functionality with proper variant handling
Show product image, title, price, and "Last purchased" indicator
Handle both single and multiple variant products appropriately
Design & Layout
Clean, centered card design with product image, details, and CTA button
Responsive layout that works on mobile, tablet, and desktop
Hover effects on product image and buttons for better interactivity
Loading state with spinner while fetching data
Smooth animations with fade-in effects (toggleable)
Use the store's brand colors and typography from the style guide
Technical Implementation
Template-based rendering for dynamic product content
Proper error handling - hide widget on API errors
Add to cart tracking for analytics and revenue attribution
Variant overlay handling for products with multiple options
Price formatting with proper currency display
Image optimization with proper aspect ratios and hover effects
User Experience
Personalized messaging with "Your Last Purchase" title
Clear call-to-action with "Add to Cart" button
Visual hierarchy emphasizing the product and reorder action
Seamless integration with existing cart and product systems
Performance optimized with minimal loading time
Configuration Options
Animation toggle (can be disabled via exposed variable)
Recommendation strategy (exposed for potential customization)
Responsive breakpoints for different screen sizes
Expected Behavior
For returning customers with purchase history: Show the last purchased product with full details and reorder functionality
For new customers or those without purchase history: Completely hide the widget (no display at all)
On loading: Show loading spinner briefly while fetching data
On error: Hide the widget gracefully without showing error messages
Integration Notes
Widget should integrate seamlessly with the store's existing design system
Use the store's installed fonts and color palette
Ensure proper tracking for conversion attribution
Handle all edge cases gracefully (missing images, prices, etc.)
Technical Specifications
Use PAST_PURCHASES recommendation strategy with size: 1
Include inventory > 0 and excludeCartItems filters
Implement proper add to cart logic for single vs multiple variants
Add WIDGET_ADD_TO_CART and WIDGET_INTERACTION tracking events
Use template-based rendering with proper attributes (name, origin)
Include loading state and error handling that hides the widget
Make animations toggleable via _vslyExposed_animationsEnabled variable`,
    sendPrompt: true,
  },
  {
    title: `Add FAQ Section`,
    image: FaqImg,
    tags: [`All`, `Social Proof`],
    prompt: `Create an FAQ section with the following spec:
      - The FAQ section should contain a list of questions and answers.
      - Each question should be clickable to expand and reveal the answer.
      - Only one answer should be expanded at a time. Clicking on a different question should collapse the previously expanded answer and expand the new one.
      - Use an accordion style for the questions and answers.
      - The questions should be styled as bold text, and the answers should be styled as regular text.
      - Ensure the FAQ section is responsive and looks good on both mobile and desktop devices.
      - Use a light background color for the FAQ section to make it stand out from the rest of the page.
      - Add some padding around the FAQ section for better spacing.
      - Try to get data from my existing FAQ page if possible.
`,
    sendPrompt: true,
  },
  {
    title: `Add a scrollable overlay popup`,
    image: ScrollableOverlay,
    tags: [`All`, `Overlays`],
    prompt: `Create a "Scrollable Popup" that will show upon page load with the following spec:

Overlay Behavior
  - Overlay can be closed via a close button.
  - Inner content should be scrollable.
  - The overlay is centered horizontally and vertically on the screen.

Overlay Components
  1.  Header - Rich-text title. don't use grid to layout the header just use flexbox that spans the full width of the overlay. aligned to the left.
  2.  Full width Image
  3.  Text Content - Long rich-text paragraph. aligned to the left

Responsive Layout
  - Mobile (viewport < desktop breakpoint): Overlay size: 100vw width × 90vh height, position on the the bottom of the screen.
    The image should be full-width (spans 100% of overlay's content area).
  - Desktop: Overlay size: 70vw width × 75vh height, centered horizontally and vertically on the screen.
    The image should be max-width 60% of the overlay's content area and centered horizontally
  `,
    sendPrompt: true,
  },
];

// Extract all unique tags from the use cases
// Manual sorting rules for tags - lower index appears first
export const TAG_SORT_ORDER: Record<string, number> = {
  All: 1,
  Upsells: 2,
};

export const getAllTags = (): string[] => {
  const tagsSet = new Set<string>();
  STARTER_USE_CASES.forEach((useCase) => {
    useCase.tags.forEach((tag) => tagsSet.add(tag));
  });

  const tags = Array.from(tagsSet);

  // Sort tags based on manual sort order, then alphabetically for remaining items
  return tags.sort((a, b) => {
    const orderA = TAG_SORT_ORDER[a] ?? Infinity;
    const orderB = TAG_SORT_ORDER[b] ?? Infinity;

    // If both have custom order, sort by order
    if (orderA !== Infinity && orderB !== Infinity) {
      return orderA - orderB;
    }

    // If only one has custom order, prioritize it
    if (orderA !== Infinity) return -1;
    if (orderB !== Infinity) return 1;

    // Both don't have custom order, sort alphabetically
    return a.localeCompare(b);
  });
};

// Filter use cases by tag
export const filterUseCasesByTag = (tag: string): StarterUseCase[] => {
  if (tag === `All`) {
    return STARTER_USE_CASES;
  }
  return STARTER_USE_CASES.filter((useCase) => useCase.tags.includes(tag));
};
